import { api } from '@/lib/axios'

/** AP-37 4.15 — Projekt aus der beauftragten Kalkulation (`/calculations/:id/project`). */
export interface CalcProjectResult {
  projectId: string
  projectNumber: string
  copied: number
  lv: { attached: boolean; reason?: string }
}

export interface CalcProjectRow {
  id: string
  projectNumber: string
  name: string
  status: string
}

export const createProjectFromCalculation = (id: string, dto: { name?: string; customerOrderRef?: string }) =>
  api.post<{ data: CalcProjectResult }>(`/calculations/${id}/project`, dto).then((r) => r.data.data)

export const fetchCalculationProjects = (id: string) => api.get<{ data: CalcProjectRow[] }>(`/calculations/${id}/projects`).then((r) => r.data.data)
